





import { Component, Vue, Inject, Prop, Emit } from "vue-property-decorator";
import Footer from "@/components/Footer.vue";
import TenantSwitch from "@/components/tenant-switch.vue";
import LanguageSwitch from "@/components/language-switch.vue";
import BaseComponent from "@/asdcom/BaseComponent";
// import Aos from "@/components/vcponlineok/animations/aos/aos.vue";
import EmailActivation from "@/views/vcponlineok/login/email-activation.vue";
// import HomePageTemplate from "./home-page-template.vue";
import LoginForm from "@/views/vcponlineok/login/login-form.vue";
import { Asdcom } from "@/asdcom/appservice.asdcom";
import {
  IActivateEmailInput,
  ActivateEmailInput
} from "@/asdcom/apiproxy/apiproxy.dto";

class ActivateEmail {
  constructor(data: any) {
    if (data) {
      this.userId = data.userId;
      this.confirmationCode = data.confirmationCode;
      if (data.tenantId) {
        this.tenantId = data.tenantId;
      }
    }
  }

  userId: number;
  confirmationCode: string;
  tenantId?: number;
}

@Component({
  components: {
    Footer,
    EmailActivation,
    TenantSwitch,
    LanguageSwitch,
    // HomePageTemplate,
    // Aos,
    LoginForm
  }
})
export default class EmailConfirmation extends BaseComponent {
  activateEmail: ActivateEmail;
  errorMsg: string | null = null;
  showChangeTenant: boolean = false;
  IsEmailConfirmed: null | boolean = null;
  IsActive: null | boolean = null;
  confirmed: null | boolean = null;

  created() {
    // http://localhost:8080/public-user/account/confirm-email?userId=20&confirmationCode=7ca3c741d65847bea206d27a574d7cd1&tenantId=2

    if (!!this.$route.query) {
    //   this.activateEmail = new ActivateEmail({
    //     userId: this.$route.query.userId,
    //     confirmationCode: this.$route.query.confirmationCode,
    //     tenantId: this.$route.query.tenantId
    //   });
      // console.error('this.payload', this.activateEmail);
     
     //this.activateEmailAction();
      const confToken=this.$route.query.c;
      const accountService = new Asdcom.AccountAppService();
      let model = { c:confToken } as ActivateEmailInput;
      // accountService.activateEmail(model).then((result:ActivateEmailOutput)=>{
      //     this.IsEmailConfirmed = result.isEmailConfirmed || null;
      //     this.IsActive = result.isActive || null;
      // });
      accountService.activateEmail(model).then(()=>{
          this.IsEmailConfirmed = true;
          this.IsActive = true;
          this.confirmed = true;
      });
    }
    else{
        this.$router.push("/");
    }

    // POST /api/services/app/Account/ResetPassword
    // POST /api/services/app/Account/ActivateEmail
  }

  public goBack(): void {
    this.$router.push("/");
  }

//   async activateEmailAction() {
//     // this.$Message.loading({
//     //     content: this.L('activateEmailPrompt'),
//     //     duration: 0
//     // });
//     const rep = await this.$store.dispatch({
//       type: "asdcom/public-user/account/activateEmailDispatch",
//       data: new ActivateEmail({
//         userId: this.activateEmail.userId,
//         confirmationCode: this.activateEmail.confirmationCode
//       })
//     });

//     // this.$Message.destroy();
//     if (rep && rep.data) {
//       const data = rep.data;
//       const result = data && data.result ? data.result : undefined;

//       const success = data.success;
//       const errors = data.error;
//       this.errorMsg = data.error;

//       if (success) {
//         this.confirmed = true;

//         if (result) {
//           this.IsEmailConfirmed = result.isEmailConfirmed;
//           this.IsActive = result.isActive;
//         }
//       }
//    }
    //     // POST /api/services/app/Account/ActivateEmail
//  }
}
